// extracted by mini-css-extract-plugin
module.exports = {"upload":"UploadFile_upload__sz1tm","uploadButton":"UploadFile_uploadButton__36cx4","uploadChips":"UploadFile_uploadChips__19G9s","uploadPerChip":"UploadFile_uploadPerChip__3rrMA"};